import React from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { useIntl } from 'react-intl';

import NavigationBar from 'carbon-react/lib/components/navigation-bar';

import { getConsolidationDetailRoutePath, getConsolidationsRoutePath, ROUTES } from '@futrli/shared-services';

import { shouldHideNav } from '../../utils/routes-utils';
import { WorkspacesNavBarContainer } from '../../workspaces/containers/workspaces-navbar-container';

/**
 * Home Management Header component.
 */
export const AppNavbar = (): JSX.Element => {
  const location = useLocation();
  const intl = useIntl();

  if (shouldHideNav(location)) {
    return <React.Fragment />;
  }

  const workspaces = [ROUTES.WORKSPACES_ROUTE];
  const workspace = [...workspaces, ROUTES.WORKSPACE_BY_ID_ROUTE];
  const workspaceSettings = [...workspace, ROUTES.WORKSPACE_BY_ID_SETTINGS_ROUTE];
  const organisations = [...workspace, ROUTES.ORGANISATIONS_ROUTE];
  const organisationsTab = [...organisations, ROUTES.ORGANISATIONS_ROUTE];
  const consolidationsTab = [...organisations, ROUTES.CONSOLIDATIONS_ROUTE];
  const organisation = [...organisations, ROUTES.ORGANISATION_BY_ID_ROUTE];
  const consolidations = [getConsolidationsRoutePath()];
  const consolidation = [getConsolidationDetailRoutePath()];
  const organisationReporting = [...organisation, ROUTES.REPORTING];

  // Warning - the order of routes is important. You want the most specific ones first!
  const allowedNavBarRoutes = [
    organisationReporting,
    organisationsTab,
    consolidationsTab,
    organisation,
    organisations,
    consolidation,
    consolidations,
    workspaceSettings,
    workspace,
    workspaces
  ];

  return (
    <NavigationBar
      variant="black"
      position="sticky"
      orientation="top"
      padding="0 20px"
      ariaLabel={intl.formatMessage({
        id: 'predict.main_navigation_bar.label',
        defaultMessage: 'Main navigation bar'
      })}
    >
      <Routes>
        {allowedNavBarRoutes.map(route => (
          <Route key={route.join('/')} path={`${route.join('')}/*`} element={<WorkspacesNavBarContainer />} />
        ))}
      </Routes>
    </NavigationBar>
  );
};
